import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { forwardRef as t } from "react";
const l = ({ children: e, ...o }, n) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 32 32",
    ref: n,
    ...o,
    children: [
      e,
      /* @__PURE__ */ i(
        "path",
        {
          fillRule: "evenodd",
          d: "M11.3 3.71 23.59 16 11.31 28.29a1 1 0 0 0 1.41 1.41l13-13a1 1 0 0 0 0-1.42l-13-13a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.43",
          clipRule: "evenodd"
        }
      )
    ]
  }
), a = t(l);
a.displayName = "IconChevronRightOutline";
export {
  a as IconChevronRightOutline
};
//# sourceMappingURL=IconChevronRightOutline.js.map
